<template>
  <div class="table-wrapper">
    <div class="jobs-template-main d-flex flex-wrap">
      <div class="d-flex align-items-center flex-wrap">
        <b-button
          v-if="$can('create', 'jobtemplates', 'encoder')"
          variant="bg-primary"
          :to="{ name: 'job-templates-new' }"
          class="mb-1 mb-lg-0"
        >
          <GjIcon
            class="icon-left"
            name="Plus"
          />
          Create
        </b-button>
        <!-- <b-form-file
          ref="pickJson"
          v-model="jsonFile"
          class="d-none"
        />
        <b-button
          v-if="$can('create', 'jobtemplates', 'encoder')"
          variant="bg-white"
          class="mb-1 mb-md-0"
          @click="uploadJsonModal = !uploadJsonModal"
        >
          <GjIcon
            name="Download"
            class="icon-left"
            size="20"
          />
          Import JSON
        </b-button>
        <b-button
          v-if="$can('list', 'jobtemplates', 'encoder')"
          variant="bg-white"
          :disabled="!isSelected"
          class="mb-1 mb-md-0 d-none d-lg-inline"
          @click="isSelected ? exportJson(selected[0].id) : ''"
        >
          <GjIcon
            name="Redirect"
            class="icon-left"
            size="20"
          />
          Export JSON
          <b-spinner
            v-if="fetchingJobTemplate"
            class="position-absolute"
          />
        </b-button> -->
      </div>
      <b-button
        v-if="$can('get', 'jobtemplates', 'encoder')"
        variant="bg-white"
        :disabled="!isSelected"
        class="mb-1 mb-md-0 d-none d-lg-inline"
        @click="
          isSelected
            ? $router.push({
              name: 'job-templates-view',
              params: { id: selected[0].id },
            })
            : ''
        "
      >
        View
      </b-button>
      <b-button
        v-if="$can('create', 'jobtemplates', 'encoder')"
        variant="bg-white"
        :disabled="!isSelected"
        class="d-none d-lg-inline"
        @click="duplicateJobTemplate"
      >
        Duplicate
      </b-button>
      <b-button
        v-if="$can('update', 'jobtemplates', 'encoder')"
        variant="bg-white"
        :disabled="!selectedIsCustom"
        class="mb-1 mb-md-0 d-none d-lg-inline"
        @click="
          selectedIsCustom
            ? $router.push({
              name: 'job-templates-edit',
              params: { id: selected[0].id },
            })
            : ''
        "
      >
        Edit
      </b-button>
      <b-button
        v-if="$can('delete', 'jobtemplates', 'encoder')"
        variant="bg-white"
        :disabled="!selectedIsCustom"
        class="mb-1 mb-md-0 d-none d-lg-inline"
        @click="() => (selectedIsCustom ? deleteJobTemplate() : '')"
      >
        Delete
      </b-button>
    </div>

    <div
      :class="
        currentBreakPoint === 'lg' || currentBreakPoint === 'xl'
          ? 'default-table'
          : ''
      "
    >
      <div class="table-actions">
        <div
          v-if="
            !fetchingJobTemplateFilters &&
              $can('list', 'jobtemplates', 'encoder')
          "
          class="d-block d-sm-flex"
        >
          <div class="mr-auto">
            <b-dropdown
              id="job-template-filter-dropdown-1"
              :text="jobTemplateTypeText"
              variant="bg-white"
              class="dropdown-icon-wrapper"
            >
              <template #button-content>
                <span>{{ jobTemplateTypeText }}</span>
                <GjIcon
                  class="icon-right"
                  name="ArrowDown"
                />
              </template>
              <b-dropdown-item
                v-for="type in jobTemplateOptions"
                :key="type.id"
                @click="jobTemplateType = type.id"
              >
                {{ type.value }}
              </b-dropdown-item>
            </b-dropdown>

            <b-dropdown
              v-if="showCategoryFilter"
              id="job-template-filter-dropdown-2"
              :text="jobTemplateCategoryText"
              variant="bg-white"
              class="dropdown-icon-wrapper "
            >
              <template #button-content>
                <span>{{ jobTemplateCategoryText }}</span>
                <GjIcon
                  class="icon-right"
                  name="ArrowDown"
                />
              </template>
              <b-dropdown-item
                v-for="category in jobTemplateCategoryOptions"
                :key="category.id"
                @click="jobTemplateCategory = category.id"
              >
                {{ category.value }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <b-input-group class="searchInputGroup mt-1 mt-sm-0">
            <b-input-group-prepend is-text>
              <b-icon-search />
            </b-input-group-prepend>
            <b-form-input
              id="filterInput"
              v-model="searchInput"
              type="search"
              class="searchInput"
              placeholder="Search by template name"
              @change="searchInputChange"
            />
          </b-input-group>
        </div>
        <div v-else>
          <div style="height:42px" />
        </div>
      </div>
      <!-- DESKTOP -->
      <div class="d-none d-lg-block">
        <b-table
          ref="table"
          :select-mode="selectMode"
          :items="jobTemplates"
          :fields="fields"
          :class="{ loaded: !fetchingJobTemplates }"
          show-empty
          selectable
          responsive
          @row-selected="onRowSelected"
        >
          <template #cell(selected)="{ rowSelected }">
            <select-button :selected="rowSelected" />
          </template>

          <template #cell(name)="data">
            <router-link
              :to="{
                name: 'job-templates-view',
                params: {
                  id: data.item.id,
                  projectId: $route.params.projectId,
                },
              }"
            >
              {{ data.value }}
            </router-link>
          </template>

          <template #cell(description)="data">
            {{ data.value || '-' }}
          </template>

          <template #cell(category)="data">
            {{ data.value || '-' }}
          </template>
          <template #empty>
            <template v-if="fetchingJobTemplates">
              <div class="loading-table text-center py-3">
                <b-spinner variant="primary" />
              </div>
            </template>
            <template v-else>
              <no-data
                no-data-text="No job templates have been added yet..."
                create-text="+ Create a job template"
                access-page="Job templates"
                icon="Section"
                :has-permissions="hasPermissions"
                @action="$router.push({ name: 'job-templates-new' })"
              />
            </template>
          </template>
        </b-table>
        <table-busy
          v-if="
            (fetchingJobTemplates && jobTemplates.length > 0) ||
              deletingJobTemplate
          "
        />
      </div>
      <!-- MOBILE -->
      <div class="position-relative mt-1 d-lg-none">
        <div :class="{ 'opacity-7': fetchingJobTemplates }">
          <template v-for="job in jobTemplates">
            <card
              :key="job.id"
              :fields="fields"
              :item="job"
              class="top-fade-in"
            >
              <template #options>
                <b-dropdown
                  id="dropdown-1"
                  right
                  variant="white"
                  @show="select(job)"
                  @hide="select(null)"
                >
                  <template #button-content>
                    <GjIcon name="Moreoptions" />
                  </template>
                  <!-- <b-dropdown-item @click="exportJson(job.id)">
                  Export JSON
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('get', 'jobtemplates', 'encoder')"
                  @click="$router.push({ name: 'job-templates-view', params: { id: job.id } })"
                >
                  View
                </b-dropdown-item> -->
                  <b-dropdown-item
                    v-if="$can('create', 'jobtemplates', 'encoder')"
                    @click="duplicateJobTemplate"
                  >
                    Duplicate
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="$can('update', 'jobtemplates', 'encoder')"
                    :disabled="!selectedIsCustom"
                    @click="
                      $router.push({
                        name: 'job-templates-edit',
                        params: { id: job.id },
                      })
                    "
                  >
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="$can('delete', 'jobtemplates', 'encoder')"
                    :disabled="!selectedIsCustom"
                    @click="deleteJobTemplate"
                  >
                    Delete
                  </b-dropdown-item>
                </b-dropdown>
              </template>
              <template #name>
                <router-link
                  :to="{
                    name: 'job-templates-view',
                    params: {
                      id: job.id,
                      projectId: $route.params.projectId,
                    },
                  }"
                >
                  {{ job.name }}
                </router-link>
              </template>
            </card>
          </template>
        </div>
        <div
          v-if="fetchingJobTemplates"
          class="mobile-loading"
        >
          <table-busy />
        </div>
        <template v-if="!fetchingJobTemplates && jobTemplates.length < 1">
          <paper-simple class="top-fade-in">
            <no-data
              class="text-center"
              no-data-text="No job templates have been added yet..."
              create-text="+ Create a job template"
              access-page="Job templates"
              icon="Section"
              :has-permissions="hasPermissions"
              @action="$router.push({ name: 'job-templates-new' })"
            />
          </paper-simple>
        </template>
      </div>

      <div
        v-if="jobTemplates.length > 0"
        class="default-pagination"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalCount"
          :per-page="pageSize"
          first-number
          last-number
        />
        <div class="results">
          Viewing {{ first.toLocaleString() }} to {{ last.toLocaleString() }} of {{ totalCount.toLocaleString() }} Items
        </div>
      </div>
    </div>
    <!-- <b-modal
      v-model="uploadJsonModal"
      centered
      cancel-variant="bg-white"
      ok-title="Import"
      :ok-disabled="!jsonFile || creatingJobTemplate"
      title="Import JSON"
      body-class="action-modal"
      @ok.prevent="importJson"
    >
      <div :class="creatingJobTemplate ? 'blur-modal-content' : ''">
        <input-field
          name="job-template-json"
          label="Job Template JSON File"
          label-position="top"
        >
          <b-form-file
            v-model="jsonFile"
            accept="application/json"
            placeholder="Select json file..."
          />
        </input-field>
      </div>
      <div
        v-if="creatingJobTemplate"
        class="d-flex position-absolute modal-loading justify-content-center align-items-center"
      >
        <b-spinner
          variant="primary"
        />
      </div>
    </b-modal> -->
  </div>
</template>
<script>
import Card from '@/components/card/Card.vue'
import fileHelperMixin from '@/mixins/file-helpers'
import { BIconSearch } from 'bootstrap-vue'

export default {
  name: 'JobTemplates',
  components: {
    Card,
    BIconSearch,
  },
  mixins: [fileHelperMixin],
  data() {
    return {
      selectMode: 'single',
      uploadJsonModal: false,
      jsonFile: null,
      jobTemplateType: -3,
      jobTemplateCategory: 0,
      searchInput: '',
      fields: [
        {
          key: 'selected',
          label: '',
          variant: 'select',
          hide: true,
        },
        { key: 'name', sortable: true, isPrimary: true },
        { key: 'description', isPrimary: true },
        { key: 'category', variant: 'time' },
      ],
      selected: [],
      hasPermissions: true,
    }
  },
  computed: {
    jobTemplateOptions() {
      return this.$store.state.jobTemplates.jobTemplateFilters
        ?.jobTemplateOptions
    },
    jobTemplateCategoryOptions() {
      return this.$store.state.jobTemplates.jobTemplateFilters
        ?.jobTemplateCategories
    },
    jobTemplateTypeText() {
      return this.jobTemplateOptions
        ? this.jobTemplateOptions.find(jt => jt.id === this.jobTemplateType)
          .value
        : ''
    },
    jobTemplateCategoryText() {
      return this.jobTemplateCategoryOptions
        ? this.jobTemplateCategoryOptions.find(
          jt => jt.id === this.jobTemplateCategory,
        ).value
        : ''
    },
    showCategoryFilter() {
      return this.jobTemplateType === 0
    },
    isSelected() {
      if (this.selected[0]) {
        return true
      }
      return false
    },
    selectedIsCustom() {
      return this.isSelected
        ? this.selected[0].jobTemplateType !== 0
            && this.selected[0].jobTemplateType !== 2
        : false
    },
    jobTemplates() {
      return this.$store.state.jobTemplates.jobTemplates
    },
    resultInfo() {
      return this.$store.state.jobTemplates.jobTemplatesResultInfo
    },
    fetchingJobTemplates() {
      return this.$store.state.jobTemplates.fetchingJobTemplates
    },
    fetchingJobTemplateFilters() {
      return this.$store.state.jobTemplates.fetchingJobTemplateFilters
    },
    deletingJobTemplate() {
      return this.$store.state.jobTemplates.deletingJobTemplate
    },
    totalCount() {
      return this.resultInfo?.totalCount
    },
    pageSize() {
      return this.resultInfo?.pageSize || 10
    },
    pageIndex() {
      return this.currentPage - 1
    },
    first() {
      return this.pageIndex * this.pageSize + 1
    },
    last() {
      return this.currentPage * this.pageSize < this.totalCount
        ? this.currentPage * this.pageSize
        : this.totalCount
    },
    fetchingJobTemplate() {
      return this.$store.state.jobTemplates.fetchingJobTemplate
    },
    creatingJobTemplate() {
      return this.$store.state.jobTemplates.creatingJobTemplate
    },
    currentBreakPoint() {
      return this.$store.getters['app/currentBreakPoint']
    },
    currentPage: {
      get() {
        return this.$store.getters['jobTemplates/currentPage']
      },
      set(val) {
        this.$store.commit('jobTemplates/SET_CURRENT_PAGE', val)
      },
    },
  },
  watch: {
    currentPage() {
      this.fetchJobTemplates()
    },
    jobTemplateType() {
      this.jobTemplateCategory = 0
      if (this.currentPage === 1) {
        this.fetchJobTemplates()
      } else {
        this.currentPage = 1
      }
    },
    jobTemplateCategory() {
      if (this.currentPage === 1) {
        this.fetchJobTemplates()
      } else {
        this.currentPage = 1
      }
    },
  },
  created() {
    if (this.$store.state.app.previousRouteName !== 'job-templates-edit') {
      this.currentPage = 1
    }
    this.init()
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    select(job) {
      this.selected = job !== null ? [job] : []
    },
    searchInputChange() {
      if (this.currentPage === 1) {
        this.fetchJobTemplates()
      } else {
        this.currentPage = 1
      }
    },
    createJobTemplate(obj) {
      this.$store
        .dispatch('jobTemplates/createJobTemplate', obj)
        .then(() => {
          this.fetchJobTemplates()
          this.successToast('Job Template imported successfully')
          this.uploadJsonModal = false
        })
        .catch(() => {
          this.errorToast("An error occurred. Couldn't import job template.")
        })
    },
    importJson(e) {
      e.preventDefault()
      if (this.jsonFile) {
        this.getFileContent(this.jsonFile)
          .then(res => {
            const tempObj = JSON.parse(res)
            this.createJobTemplate(tempObj)
          })
          .catch(() => {
            this.errorToast('An error occurred')
          })
      }
    },
    exportJson(id) {
      this.$store
        .dispatch('jobTemplates/fetchJobTemplateById', id)
        .then(res => {
          const fileName = `job-template&id_${res.data.id}&name_${res.data.name}`
          this.objectToJsonFile(res.data, fileName)
        })
        .catch(() => {
          this.errorToast("Something went wrong, couldn't export as json")
        })
    },
    onRowSelected(items) {
      this.selected = items
    },
    deleteJobTemplate() {
      this.confirmDelete(
        'Delete job template',
        'Are you sure you want to delete this job template?',
      ).then(ok => {
        if (ok) {
          this.$store
            .dispatch('jobTemplates/deleteJobTemplate', this.selected[0].id)
            .then(() => {
              this.successToast('Job template deleted successfully')
              if (this.jobTemplates.length === 0 && this.currentPage > 1) {
                this.currentPage = 1
              } else {
                this.fetchJobTemplates()
              }
            })
            .catch(() => {
              this.errorToast('An error occurred', 'Error')
            })
        }
      })
    },
    duplicateJobTemplate() {
      this.$store
        .dispatch('jobTemplates/duplicateJobTemplate', this.selected[0].id)
        .then(() => {
          if (this.currentPage === 1) {
            this.fetchJobTemplates()
          } else {
            this.currentPage = 1
          }
        })
        .catch(() => {
          this.errorToast('An error occurred', 'Error')
        })
    },
    fetchJobTemplates() {
      this.$store
        .dispatch('jobTemplates/fetchJobTemplates', {
          page: this.pageIndex,
          category: this.jobTemplateCategory,
          type: this.jobTemplateType,
          search: this.searchInput,
        })
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasPermissions = false
            return
          }
          this.errorToast("Couldn't fetch job templates.", 'Error')
        })
    },
    fetchJobTemplateFilters() {
      this.$store.dispatch('jobTemplates/fetchJobTemplateFilters').catch(() => {
        this.errorToast('An error occurred', 'Error')
      })
    },
    init() {
      this.fetchJobTemplateFilters()
      this.fetchJobTemplates()
      if (this.$route.params.toast) {
        const { toast } = this.$route.params
        this.generalToast(toast.message, toast.title, toast.variant)
      }
    },
  },
}
</script>

<style scoped>
.searchInputGroup {
  width: 250px;
}
.searchInput {
  margin-right: 0;
}
</style>
